import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ShoppingCart, ClipboardList, MessageCircle } from 'lucide-react';
import { useApp } from '../contexts/AppContext';

export default function BottomNav() {
  const { t, cart, whatsappNumber } = useApp();
  const navigate  = useNavigate();
  const location  = useLocation();

  const tabs = [
    { key: 'home',    icon: Home,          label: t.home,     path: '/'       },
    { key: 'cart',    icon: ShoppingCart,  label: t.cart,     path: '/cart',   badge: cart.length },
    { key: 'orders',  icon: ClipboardList, label: t.myOrders, path: '/orders'  },
    { key: 'contact', icon: MessageCircle, label: t.contact,  path: null       },
  ];

  const handleTab = (tab) => {
    if (!tab.path) {
      if (whatsappNumber) window.open(`https://wa.me/${whatsappNumber.replace(/\D/g, '')}`, '_blank');
      return;
    }
    navigate(tab.path);
  };

  const isActive = (path) =>
    path && (path === '/' ? location.pathname === '/' : location.pathname.startsWith(path));

  return (
    <nav
      className="bottom-nav-bar"
      aria-label="Bottom navigation"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: '#fff',
        borderTop: '1px solid var(--border)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.08)',
      }}
    >
      {tabs.map(tab => {
        const active = isActive(tab.path);
        const Icon   = tab.icon;
        return (
          <button
            key={tab.key}
            onClick={() => handleTab(tab)}
            aria-label={tab.label}
            aria-current={active ? 'page' : undefined}
            style={{
              flex: 1,
              padding: '10px 0 8px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 4,
              color: active ? 'var(--brand)' : 'var(--text-3)',
              transition: 'color var(--ease)',
              position: 'relative',
              fontFamily: 'inherit',
            }}
          >
            {/* Top indicator */}
            {active && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: '25%',
                  right: '25%',
                  height: 2.5,
                  background: 'var(--brand)',
                  borderRadius: '0 0 3px 3px',
                }}
              />
            )}

            {/* Icon + badge */}
            <div style={{ position: 'relative' }}>
              <Icon
                size={22}
                strokeWidth={active ? 2.5 : 1.8}
                color={active ? 'var(--brand)' : 'var(--text-3)'}
              />
              {tab.badge > 0 && (
                <span
                  style={{
                    position: 'absolute',
                    top: -5,
                    right: -8,
                    background: '#22C55E',
                    color: '#fff',
                    borderRadius: 'var(--r-full)',
                    minWidth: 16,
                    height: 16,
                    padding: '0 3px',
                    fontSize: 10,
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {tab.badge}
                </span>
              )}
            </div>

            {/* Label */}
            <span
              style={{
                fontSize: 10.5,
                fontWeight: active ? 700 : 400,
                color: active ? 'var(--brand)' : 'var(--text-3)',
                lineHeight: 1,
              }}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
